import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'fuse-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
})
export class FuseMessageDialogComponent {

    public titleMessage: String;
    public principalMessage: string;
    public contentMessage: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<FuseMessageDialogComponent>} dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<FuseMessageDialogComponent>
    ) {
    }

}
